import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {Scanner3dModel} from '../../../api/entity/scanner3d.model';
import {Scanner3dConverter} from '../../../api/entity/converter/scanner3d.converter';
import {Scanner3dDataService} from './scanner3dData.service';

@Injectable()
export class Scanner3dDataServiceAdapter extends AbstractDataServiceDtoAdapter<Scanner3dModel, Scanner3dConverter> {
    constructor(dataService: Scanner3dDataService, converter: Scanner3dConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): Scanner3dModel {
        return new Scanner3dModel();
    }
}
